import React from 'react';

const Footer = () => {
  return (
    <div style={{
      "fontFamily": "'Lato', sans-serif"
    }} className="text-center p-2">
      <p> Created By <span className="text-warning">Reya</span> ||  All Rights Reserved &#169; <span className="text-warning"> {(new Date()).getFullYear()} </span></p>
    </div>
  );
};

export default Footer;